import React from "react";
import ComingSoon from "../../../components/ComingSoon";

export default function ContentWriting() {
  return <ComingSoon title="Content Writing" />;
}
